/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBatteryThreeQuarters: {
  name: 'battery-three-quarters';
  data: string;
} = {
  name: 'battery-three-quarters',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 5A1.5 1.5 0 0 1 2 3.5h10A1.5 1.5 0 0 1 13.5 5v6a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 11V5ZM2 4.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5H2ZM3.5 6a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0V6Zm2 0a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0V6ZM7 5.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0V6Zm6 0a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0V6Z" fill="currentColor"/></svg>`,
};
